import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Araku from "../images/indian-city-buildings-scene.jpg";
import Beans from '../images/akha-farmers.jpg'

const BeanMotive = () => {
  const sectionStyle = {
    background:"rgb(227, 237, 234)",  //rgb(249, 240, 219)  
    padding: "40px 20px",
    fontFamily: '"Courier New", Courier, monospace',
    color: "#4d1f00",
    textAlign: "center",
    position: "relative",
  };

  const headingStyle = {
    // fontSize: '18px',
    marginBottom: "50px",
  };

  const beanContainer = {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    maxWidth: "600px",
    margin: "0 auto",
    gap: "40px",
  };

  const beanItem = {
    display: "flex",
    alignItems: "center",
    fontSize: "22px",
  };

  const letterStyle = {
    fontSize: "40px",
    fontWeight: "bold",
    marginRight: "20px",
    width: "40px",
    textAlign: "center",
  };
  const containerStyle = {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 40px 40px 40px",
    backgroundColor: "rgb(232, 240, 238)",
  };

  const imageContainerStyle = {
    flex: "1 1 300px",
    padding: "20px",
  };

  const textContainerStyle = {
    flex: "1 1 300px",
    padding: "20px",
    fontFamily: "Arial, sans-serif",
    fontSize: "18px",
    lineHeight: "1.6",
    color: "#333",
  };
  const imageStyle = {
    width: "100%",
    height: "auto",
    // borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
  };

  return (
    <>
      <Navbar />
      <div style={containerStyle}>
        <div style={imageContainerStyle}>
          <img src={Araku} alt="Araku Valley" style={imageStyle} />
        </div>
        <div style={textContainerStyle}>
          <h2>Araku Valley</h2>
          <p>
            Araku Valley, nestled in the Eastern Ghats of India, is a hidden gem
            for coffee cultivation. Its high altitude, rich volcanic soil, and
            cool climate create ideal conditions for growing high-quality
            Arabica beans. What truly sets Araku apart is its biodiverse
            ecosystem and the organic, community-driven farming practices led by
            indigenous tribes.
          </p>
          <p>
            These farmers use age-old, sustainable techniques, nurturing each
            plant with care and respect for the land. The result is a coffee
            that is not only smooth and aromatic, but also carries the unique
            terroir of the valley—earthy, floral, and distinctly Araku.
          </p>
        </div>
      </div>
      <div style={containerStyle}>
        <div style={textContainerStyle}>
          <h2>100% Arabica AA grade Beans</h2>
          <p>
            The pinnacle of premium coffee quality sourced from select
            high-altitude plantations, these beans are larger, denser, and more
            uniform than lower-grade varieties—ensuring a consistent,
            full-bodied brew. Known for their smooth texture and vibrant flavor
            profile, Arabica AA beans deliver subtle notes of fruit, florals,
            and a gentle acidity that’s both bright and refined. 
          </p>
          <p>
          Grown with care
            and hand-picked at peak ripeness, this grade guarantees not just
            superior taste but also a commitment to craftsmanship and origin
            integrity. Ideal for pour-overs, French press, or even a classic
            espresso, these beans elevate every cup into a gourmet experience.
          </p>
        </div>
        <div style={imageContainerStyle}>
          <img src={Beans} alt="Araku Valley" style={imageStyle} />
        </div>
      </div>
      <div style={sectionStyle}>
        <p style={headingStyle}>
          The impact we make can be simply explained by our{" "}
          <strong> ‘ARAKU’</strong> motive, which guides everything we do.
        </p>
        <div style={beanContainer}>
          <div style={beanItem}>
            <span style={letterStyle}>A</span>
            <span>Awaken the senses</span>
          </div>
          <div style={beanItem}>
            <span style={letterStyle}>R</span>
            <span>Rooted in tradition</span>
          </div>
          <div style={beanItem}>
            <span style={letterStyle}>A</span>
            <span>Art in every roast</span>
          </div>
          <div style={beanItem}>
            <span style={letterStyle}>K</span>
            <span>Kind to the Earth</span>
          </div>
          <div style={beanItem}>
            <span style={letterStyle}>U</span>
            <span>Uniting people and purpose</span>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BeanMotive;
